import { GraphQLClient } from "graphql-request";
import { setting } from "./setting";
// import { API_HOST } from "./config"

const url = setting.gqlApiHost + "/graphql";
const options = {
  method: "post"
};
export default new GraphQLClient(url, options);
